/**
 * Tenant Login Page
 * =================
 * صفحة تسجيل دخول الشركات
 */

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTenantAuth } from '../../context/TenantAuthContext';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login, error } = useTenantAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;

    setLoading(true);
    const success = await login(email, password);
    setLoading(false);

    if (success) {
      navigate('/tenant/dashboard');
    }
  };

  return (
    <div className="tenant-login">
      <div className="tenant-login__card">
        <div className="tenant-login__header">
          <div className="tenant-login__logo">
            <svg viewBox="0 0 40 40" fill="none">
              <rect width="40" height="40" rx="10" fill="url(#gradient)" />
              <path d="M12 20L18 26L28 14" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              <defs>
                <linearGradient id="gradient" x1="0" y1="0" x2="40" y2="40">
                  <stop stopColor="#0ea5e9"/>
                  <stop offset="1" stopColor="#0284c7"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
          <h1 className="tenant-login__title">بوابة الشركات</h1>
          <p className="tenant-login__subtitle">سجل دخولك للوصول إلى لوحة التحكم</p>
        </div>

        <form className="tenant-login__form" onSubmit={handleSubmit}>
          {error && (
            <div className="tenant-login__error">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              <span>{error}</span>
            </div>
          )}

          <div className="tenant-login__field">
            <label className="tenant-login__label">البريد الإلكتروني</label>
            <div className="tenant-login__input-wrapper">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <input
                type="email"
                className="tenant-login__input"
                placeholder="example@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
          </div>

          <div className="tenant-login__field">
            <label className="tenant-login__label">كلمة المرور</label>
            <div className="tenant-login__input-wrapper">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <input
                type={showPassword ? 'text' : 'password'}
                className="tenant-login__input"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                className="tenant-login__password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          <div className="tenant-login__options">
            <label className="tenant-login__remember">
              <input type="checkbox" />
              <span>تذكرني</span>
            </label>
            <a href="#forgot" className="tenant-login__forgot">نسيت كلمة المرور؟</a>
          </div>

          <button
            type="submit"
            className="tenant-login__submit"
            disabled={loading || !email || !password}
          >
            {loading ? (
              <span className="tenant-login__spinner" />
            ) : (
              <>
                <span>تسجيل الدخول</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="5" y1="12" x2="19" y2="12"/>
                  <polyline points="12 5 19 12 12 19"/>
                </svg>
              </>
            )}
          </button>
        </form>

        <div className="tenant-login__footer">
          <p>شركة مياه جديدة؟ <Link to="/register">سجّل شركتك</Link></p>
        </div>
      </div>

      <div className="tenant-login__branding">
        <span>Watrly</span> © 2024
      </div>
    </div>
  );
};

export default LoginPage;
